import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class UsermanagementService {

  private apiUrl;
  private lsProfile;
  private access_token;
  private userId;
  private headers: HttpHeaders = new HttpHeaders();

  

  constructor(private config: ConfigService, private auth: AuthService, private http: HttpClient){
    this.apiUrl = this.config.basePath + '/api/farmers';
    //let tmpString = localStorage.getItem('profile') || {};
    this.lsProfile = localStorage.getItem('profile') || {};
    this.access_token = localStorage.getItem('access_token');
    
    if (this.auth.userProfile && this.lsProfile) {
      console.log('this.access_token',this.access_token)
      const userProfile = JSON.parse(this.lsProfile);
      this.userId = userProfile.id;
      this.headers = this.headers.append('Authorization', this.access_token);
    }
  }
  
  getSubUsers(): Observable<any[]> {
    const options = {
      headers: this.headers,
      params: new HttpParams().set('userId', this.userId)
    };

    const params = new HttpParams().set('userId', this.userId); // Create parameters
    return this.http.get<any[]>(`${this.apiUrl}/getSubUsers`, options ); 
  }

  addSubUser(subUserInfo: any): Observable<any> {
    const options = {
      headers: this.headers
    };
    console.log('options', options)
    return this.http.post<any>(`${this.apiUrl}/createSubUser`, subUserInfo, options); // Adjust payload if needed 
  }

  updateSubUser(subUserInfo: any): Observable<any>{
    const options = {
      headers: this.headers
    };

    return this.http.put<any>(`${this.apiUrl}/updateSubUser`, subUserInfo, options); // Adjust payload if needed
  }

  deleteSubUser(subUserInfo: any): Observable<any>{
    console.log('DELETE ID: ', subUserInfo)
    const options = {
      headers: this.headers,
      body: { id: subUserInfo.id }
    };

   return this.http.delete<any>(`${this.apiUrl}/deleteSubUser`, options); // Adjust payload if needed
  }
  
}
